import { Controller } from "@hotwired/stimulus";

/*

Use this controller to open PDFs in a new tab for preview.

It will look over any data-controller="pdf-embed" attribute present in a link and
will open the PDF that is in the href attribute of that link in a new tab.

Sample usage:
  1. Plain HTML:
     <a href="link to your PDF file" data-controller="pdf-embed" class="text-gray-700 font-bold ps-5">
  2. Rails powered by Stejar:
      <%= link_to rails_blob_path(@asset.file, disposition: 'inline'), target: :_blank,
              data: { controller: @asset.pdf? ? 'pdf-embed' : '' },
              class: "text-sky-600 hover:text-sky-800  w-full hover:underline flex items-top",
              title: @asset.pdf? ? 'Click pentru a vizualiza' : '' do %>
        <div class="h-5 w-5 me-3">
          <%= image_tag asset_path(@asset.file_icon) %>
        </div>
        <div class="flex-1">
          <%= @asset.t(:title) %>
        </div>
      <% end %>
   <% end %>
*/

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.openPDF.bind(this));
  }

  openPDF(event) {
    event.preventDefault();
    const pdfUrl = this.element.getAttribute('href');
    window.open(pdfUrl, '_blank');
  }

  disconnect() {
    this.element.removeEventListener('click', this.openPDF.bind(this));
  }
}
